import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import type { PaymentMethodsApi } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import {
  createCMSQuery,
  getCMSImageFieldsUrl,
  getCMSLocale,
} from '@/modules/cms';

export const useCMSPaymentMethods = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const query = useMemo(
    () =>
      createCMSQuery({
        ...getCMSLocale(language),
        populate: {
          methods_groups: {
            populate: {
              methods: {
                populate: {
                  ...getCMSImageFieldsUrl('image'),
                  ...getCMSImageFieldsUrl('image_grayscale'),
                },
              },
            },
          },
        },
      }),
    [language]
  );

  const {
    data = null,
    error,
    isLoading,
  } = useSWRImmutable<PaymentMethodsApi>(
    `/payment-method?${query}`,
    fetcherCMS
  );
  return {
    cmsPaymentMethods: data,
    isLoading,
    isError: error,
  };
};
